<template>
  <v-container>
    <div>
      <div
        v-if="loading"
        :style="styleObject"
        class="text-center"
      >
        <v-icon
          light
          class="custom-loader"
          :style="styleObject"
        >
          mdi-cached
        </v-icon>
        Carregando dados...
      </div>
      <div
        v-else-if="error"
        class="alert alert-danger"
      >
        {{ error }}
      </div>
      <v-row>
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="12"
        >
          <div
            v-if="exibirFaturamento"
            class="text-center"
          >
            Faturamento Atual
          </div>
          <div
            v-if="exibirFaturamento"
            id="valorFaturamentoCliente"
            class="text-center"
          >
            {{ faturamentoCliente }}
          </div>
          <div
            v-if="exibirFaturamento"
            class="text-center"
          >
            Faturamento Ano Anterior
          </div>
          <div
            v-if="exibirFaturamento"
            id="valorFaturamentoClienteAnterior"
            class="text-center"
          >
            {{ faturamentoClienteAnterior }}
          </div>
          <div
            class="text-center"
            width="10px"
          >
            <dashboard-porcentagem-faturamento-clientes />
          </div>
          <div
            class="text-center"
            width="30px"
          >
            <dashboard-evolucao-faturamento-cliente />
          </div>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
  import Clientes from '../../../../../../services/clientes'
  import eventEmit from '../../../core/EventoEmit'

  export default {
    name: 'ShowExtratoClientesFaturados',
    emits: ['setFaturamentoPorcentagemCliente', 'setFaturamentoDadosCliente'],
    components: {
      DashboardPorcentagemFaturamentoClientes: () => import('../../../../graficos/Clientes/ExtratoClientes/PorcentagemFaturamento'),
      DashboardEvolucaoFaturamentoCliente: () => import('../../../../graficos/Clientes/ExtratoClientes/EvolucaoFaturamentoCliente'),
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      loading: false,
      error: null,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      vendedorSelect: [],
      areaSelect: [],
      redeSelect: [],
      supervisorSelect: [],
      receita: [],
      categoria: [],
      promotor: [],
      selectCliente: JSON.parse(localStorage.clienteSelect),
      exibirFaturamento: false,
      faturamentoCliente: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
      faturamentoClienteAnterior: parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
    }),

    created () {
      eventEmit.$on('set-comparativo-evolucao-cliente', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('set-comparativo-evolucao-cliente', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, ultimoDia, select, selectCliente, vendedor, area, rede, supervisor, receita, categoria, promotor) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = ultimoDia
        this.select = select
        this.selectCliente = selectCliente
        this.vendedorSelect = vendedor
        this.areaSelect = area
        this.redeSelect = rede
        this.supervisorSelect = supervisor
        this.receita = receita
        this.categoria = categoria
        this.promotor = promotor

        this.showDadosFaturamentoCliente()
      },

      async showDadosFaturamentoCliente () {
        this.loading = true
        this.exibirFaturamento = false

        this.faturamentoCliente = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
        this.faturamentoClienteAnterior = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

        await Clientes.showFaturamentoCliente(this.primeiroDia, this.ultimoDia, this.select, this.selectCliente, localStorage.tokencontrato, this.vendedorSelect, this.areaSelect, this.redeSelect, this.supervisorSelect, this.receita, this.categoria, this.promotor).then(resposta => {
          if (resposta.data.status) {
            this.faturamentoCliente = resposta.data.faturamentoCliente.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            this.faturamentoClienteAnterior = resposta.data.faturamentoClienteAnterior.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            eventEmit.$emit('set-faturamento-porcentagem-cliente', resposta.data.porcentagemAtual, resposta.data.porcentagemAnterior)

            eventEmit.$emit('set-faturamento-dados-cliente', resposta.data.dadosFaturamento, resposta.data.labels)
          } else if (resposta.data.msg === 'Não há faturamento para o(s) cliente(s) selecionado') {
            this.faturamentoCliente = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
            this.faturamentoClienteAnterior = parseFloat(0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })

            eventEmit.$emit('set-faturamento-porcentagem-cliente', 0, 0)

            eventEmit.$emit('set-faturamento-dados-cliente', 0, 0)

            this.showSnackbar('error', 3000, resposta.data.msg)
          } else if (resposta.data.msg === 'Data Final não pode ser mair que a data inicial') {
            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => {
          this.loading = false

          this.exibirFaturamento = true
        })
      },
    },
  }
</script>

<style scoped>
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }
</style>
